<div [formGroup]="form">
  @for (key of values; track key) {
    <div class="mb-3 row">
      <label class="col-2 col-form-label">{{ key }}</label>
      <div class="col">
        <input
          type="text"
          class="form-control"
          [formControl]="control(key)"
          [class.form-control-plaintext]="disabled" />
      </div>
      <div class="col-1">
        @if (!disabled) {
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="removeValue(key)"
            (keydown.enter)="removeValue(key)">
            <i class="fa fa-trash"></i>
          </button>
        }
      </div>
    </div>
  }
  @if (!disabled) {
    <div class="mb-3 row">
      <div class="col-2">
        <input type="text" class="form-control" [formControl]="newKey" />
      </div>
      <div class="col">
        <input type="text" class="form-control" [formControl]="newValue" />
      </div>
      <div class="col-1" [class.isInvalid]="errors && errors.new">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="onAddKey()"
          (keydown.enter)="onAddKey()">
          <i class="fa fa-plus"></i>
        </button>
      </div>
      @if (errors && errors.new) {
        <div class="invalid-feedback">
          {{ errors.new }}
        </div>
      }
    </div>
  }
  @if (form.get('new.key').dirty && !form.get('new.key').value.length) {
    <div class="row">
      <div class="col-6">
        <small class="text-danger"> key cannot be null </small>
      </div>
    </div>
  }
</div>
